import {
  ChevronLeft,
  ChevronRight,
  Loader,
  LucideUpload,
  Search,
  SortAsc,
  User,
  CheckCircle,
  Clock,
  XCircle,
  Download,
  FileText,
  Siren,
  Bell,
  Split,
  CircleCheck,
  InfoIcon,
  Info,
  Folder,
  Circle,
} from "lucide-react";
import { useState } from "react";
import Pagination from "../../shared/Pagination";
import {
  CopyDataCard,
  CopyDataLocation,
  DataCard,
} from "../../shared/DataCard";
import ActionCard from "../../shared/ActionCard";
import { useNavigate, useParams } from "react-router-dom";
import SingleLoanSkeleton from "../../skeletons/SingleLoanSkeleton";
import { useFormatAmount } from "../../hooks/useFormatAmount";
import { useFormattedDate } from "../../hooks/useFormattedDate";
import { useMutation, useQuery } from "react-query";
import dayjs from "dayjs";
import {
  declineMyDisbursement,
  disburseByBank,
  disburseMyLoan,
  getLoanById,
  getLoanPenalties,
} from "../../sdk/loans/loans";
import decimalToDMS from "../../utils/location";
import {
  getloanTransactions,
  makeManualPayment,
} from "../../sdk/transactions/transaction";
import { useError } from "../../context/ErrorProvider";
import DisburseSuccess from "../../components/disburse/DisburseSuccess";
import RecordBankTransaction from "../../components/disburse/RecordBankTransaction";
import ReviewDisburseDetails from "../../components/disburse/ReviewDisburseDetails";
import DisbursePhone from "../../components/disburse/DisbursePhone";
import DisburseType from "../../components/disburse/DisburseType";
import DisburseDetails from "../../components/disburse/DisburseDetails";
import DeclineDisburse from "../../components/disburse/DeclineDisburse";
import DeclineDisburseSuccess from "../../components/disburse/DeclineDisburseSuccess";
import downloadFromUrl from "../../utils/download";
import TransactionFilter from "../../components/filter/TransactionFilter";
import Loading from "../../shared/Loading";
import { hasPermission } from "../../utils/permissions";
import useAuth from "../../hooks/useAuth";
import { Button, Dropdown } from "antd";
import {
  exportAllLoanTransactions,
  exportAllSelectedLoanTransactions,
} from "../../sdk/exports/export";
import { downloadExportFile } from "../../utils/export";
import LoanTransaction from "../../components/transaction/LoanTransaction";
import ManualTransaction from "../../components/transaction/ManualTransaction";
import ManualPaymentPrompt from "../../components/transaction/ManualPrompt";
import ManualPaymentSuccess from "../../components/transaction/ManualPaymentSuccess";

const Loan = () => {
  const { auth } = useAuth();
  const [activeTab, setActiveTab] = useState("Loan Details");
  const [totalPages, setTotalPages] = useState(50);
  const [openIndexes, setOpenIndexes] = useState([]);
  const navigate = useNavigate();
  const formatAmount = useFormatAmount();
  const formattedDate = useFormattedDate();
  const { id } = useParams();
  const { showError } = useError();
  const [totalItems, setTotalItems] = useState(0);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [fromDate, setFromDate] = useState("2023-11-23");
  const [toDate, setToDate] = useState("");
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [method, setMethod] = useState("");
  const [type, setType] = useState("");
  const [loanTransactions, setLoanTransactions] = useState([]);
  const [openTransactionFilter, setOpenTransactionFilter] = useState(false);
  const [openDisburseDetails, setOpenDisburseDetails] = useState(false);
  const [openDisburseType, setOpenDisburseType] = useState(false);
  const [openDisbursePhone, setOpenDisbursePhone] = useState(false);
  const [openLoanTransaction, setOpenLoanTransaction] = useState(false);
  const [openManualTransaction, setOpenManualTransaction] = useState(false);
  const [selectedLoanTransaction, setSelectedLoanTransaction] = useState({});
  const [openReviewDisburseDetails, setOpenReviewDisburseDetails] =
    useState(false);
  const [openRecordBankTransaction, setOpenRecordBankTransaction] =
    useState(false);
  const [openDisburseSuccess, setOpenDisburseSuccess] = useState(false);
  const [openDeclineDisburse, setOpenDeclineDisburse] = useState(false);
  const [openDeclineDisburseSuccess, setOpenDeclineDisburseSuccess] =
    useState(false);
  const today = new Date().toISOString().split("T")[0];
  const [disburseDetails, setDisburseDetails] = useState({
    disburseType: "MPESA",
    phoneNumber: "",
    reference: "",
    customerName: "",
    disburseDate: today,
  });

  const toggleLoanTransaction = (txn) => {
    setSelectedLoanTransaction(txn);
    setOpenLoanTransaction(true);
  };
  const closeLoanTransaction = () => {
    setOpenLoanTransaction(false);
  };

  const toggleTransactionFilter = () => {
    setOpenTransactionFilter(true);
  };
  const closeTransactionFilter = () => {
    setOpenTransactionFilter(false);
  };

  const [declineDisburseDetails, setDeclineDisburseDetails] = useState({
    reason: "",
    supportingDocumentUrl: "",
  });

  const [disburseTransaction, setDisburseTransaction] = useState({
    referenceNumber: "",
    phoneNumber: "",
    transactionAmount: "",
    transactionDate: today,
    receiptUrl: "",
    bank: "",
    accountNumber: "",
  });

  const toggleDisburseDetails = () => {
    setOpenDisburseDetails(true);
  };
  const closeDisburseDetails = () => {
    setOpenDisburseDetails(false);
  };

  const toggleDeclineDisburse = () => {
    setOpenDeclineDisburse(true);
  };
  const closeDeclineDisburse = () => {
    setOpenDeclineDisburse(false);
  };

  const handleDeclineDisburseSuccess = () => {
    declineDisbursement();
  };

  const toggleDeclineDisburseSuccess = () => {
    setOpenDeclineDisburseSuccess(true);
  };
  const closeDeclineDisburseSuccess = () => {
    setOpenDeclineDisburseSuccess(false);
  };

  const handleDeclineDisburse = () => {
    closeDisburseDetails();
    toggleDeclineDisburse();
  };

  const handleDisburseSuccess = () => {
    disburseLoanByBank();
  };

  const toggleDisburseSuccess = () => {
    setOpenDisburseSuccess(true);
  };
  const closeDisburseSuccess = () => {
    setOpenDisburseSuccess(false);
  };

  const toggleRecordBankTransaction = () => {
    setOpenRecordBankTransaction(true);
  };
  const closeRecordBankTransaction = () => {
    setOpenRecordBankTransaction(false);
  };

  const handleRecordDisbursement = () => {
    disburseLoan();
  };

  const handleReviewDisburseDetails = () => {
    closeDisbursePhone();
    toggleReviewDisburseDetails();
  };

  const toggleReviewDisburseDetails = () => {
    setOpenReviewDisburseDetails(true);
  };
  const closeReviewDisburseDetails = () => {
    setOpenReviewDisburseDetails(false);
  };

  const handleAccountNumber = () => {
    closeDisburseType();
    toggleRecordBankTransaction();
  };

  const handleChooseDisbursePhone = () => {
    closeDisburseType();
    toggleDisbursePhone();
  };

  const toggleDisbursePhone = () => {
    setDisburseDetails((prev) => ({
      ...prev,
      phoneNumber: loan?.loanApplication?.customer?.mobileno || "",
    }));
    setOpenDisbursePhone(true);
  };
  const closeDisbursePhone = () => {
    setOpenDisbursePhone(false);
  };

  const handleChooseDisburseType = () => {
    closeDisburseDetails();
    toggleDisburseType();
  };

  const toggleDisburseType = () => {
    setOpenDisburseType(true);
  };
  const closeDisburseType = () => {
    setOpenDisburseType(false);
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const toggleGuarantor = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  function generateUniqueId(length = 14) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let id = "";
    for (let i = 0; i < length; i++) {
      const randIndex = Math.floor(Math.random() * chars.length);
      id += chars[randIndex];
    }
    return id;
  }

  const { mutate: disburseLoan, isLoading: loadingDisbursement } = useMutation({
    mutationKey: ["disburse loan", id],
    mutationFn: () =>
      disburseMyLoan(
        id,
        loan?.loanApplication?.loanAmount,
        disburseDetails?.disburseType,
        generateUniqueId(13),
        disburseDetails?.phoneNumber,
        disburseDetails?.customerName,
        disburseDetails?.disburseDate,
      ),
    onSuccess: () => {
      closeReviewDisburseDetails();
      refetchLoan();
      refetchTransaction();
      toggleDisburseSuccess();
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const { mutate: disburseLoanByBank, isLoading: loadingDisbursementByBank } =
    useMutation({
      mutationKey: ["disburse loan by bank", id],
      mutationFn: () =>
        disburseByBank(
          id,
          disburseTransaction?.transactionAmount,
          "Bank",
          disburseTransaction?.referenceNumber,
          disburseTransaction?.transactionDate,
          disburseTransaction?.bank,
          disburseTransaction?.accountNumber,
          disburseTransaction?.receiptUrl,
        ),
      onSuccess: () => {
        closeRecordBankTransaction();
        refetchLoan();
        refetchTransaction();
        toggleDisburseSuccess();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const { mutate: declineDisbursement, isLoading: loadingDeclineDisbursement } =
    useMutation({
      mutationKey: ["decline disbursement", id],
      mutationFn: () =>
        declineMyDisbursement(
          id,
          declineDisburseDetails?.reason,
          declineDisburseDetails?.supportingDocumentUrl,
        ),
      onSuccess: () => {
        closeDeclineDisburse();
        refetchLoan();
        refetchTransaction();
        toggleDeclineDisburseSuccess();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "successful":
        return (
          <CircleCheck className="text-green-600 bg-green-100 rounded-full p-1 w-6 h-6" />
        );
      case "pending":
        return (
          <Clock className="text-yellow-600 bg-yellow-100 rounded-full p-1 w-6 h-6" />
        );
      case "failed":
        return (
          <XCircle className="text-red-600 bg-red-100 rounded-full p-1 w-6 h-6" />
        );
      default:
        return (
          <Clock className="text-gray-600 bg-gray-100 rounded-full p-1 w-6 h-6" />
        );
    }
  };

  const getStatus = (paid, schedule) => ({
    label: paid
      ? "Paid"
      : Number(schedule?.paidAmount) !== 0 &&
          Number(schedule?.paidAmount) < Number(schedule?.amount)
        ? "Partial"
        : "Unpaid",
    color: paid
      ? "bg-green-100 text-green-700"
      : Number(schedule?.paidAmount) !== 0 &&
          Number(schedule?.paidAmount) < Number(schedule?.amount)
        ? "bg-yellow-400 text-[#000000]"
        : "bg-red-100 text-red-700",
  });

  const switchTab = (tab) => {
    setActiveTab(tab);
  };

  const tabClass = (tab) =>
    `w-[14.28%] cursor-pointer flex items-center justify-center h-full ${
      activeTab === tab
        ? "border-b-[5px] border-[#000000] bg-[#FFDEDE] text-black font-medium"
        : "text-[#5C5C5C] bg-white text-[16px] font-normal"
    }`;

  const {
    data: loan,
    refetch: refetchLoan,
    isLoading,
  } = useQuery({
    queryKey: ["loan", id],
    queryFn: async () => {
      const response = await getLoanById(id);
      return response.data.data;
    },
  });

  const { data: penalties } = useQuery({
    queryKey: ["loan penalties", id],
    queryFn: async () => {
      const response = await getLoanPenalties(id);
      return response.data.data;
    },
  });

  const {
    refetch: refetchTransaction,
    isRefetching: isRefetchingTransactions,
  } = useQuery({
    queryKey: [
      "loan transactions",
      id,
      page,
      limit,
      fromDate,
      toDate,
      search,
      status,
      method,
      type,
    ],
    queryFn: async () => {
      const response = await getloanTransactions(
        id,
        page,
        limit,
        fromDate,
        toDate,
        search,
        status,
        method,
        type,
      );
      return response.data.data;
    },
    onSuccess: (data) => {
      setLoanTransactions(data.data);
      setPage(data.page);
      setTotalPages(data.totalPages);
      setLimit(data.limit);
      setTotalItems(data?.total);
    },
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  const formatValue = (val) =>
    val && val.toString().trim() !== "" ? val : "N/A";

  const handleSelectTransaction = (txnId) => {
    setSelectedTransactions((prev) =>
      prev.includes(txnId)
        ? prev.filter((id) => id !== txnId)
        : [...prev, txnId],
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = loanTransactions.map((txn) => txn.id);
      setSelectedTransactions(allIds);
    } else {
      setSelectedTransactions([]);
    }
  };

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalItems);

  const items = [
    {
      key: "csv",
      label: "Export as CSV",
      onClick: () => exportLoanTransactions({ format: "csv" }),
    },
    {
      key: "pdf",
      label: "Export as PDF",
      onClick: () => exportLoanTransactions({ format: "pdf" }),
    },
  ];

  const selectedItems = [
    {
      key: "csv",
      label: "Export as CSV",
      onClick: () => exportSelectedLoanTransactions({ format: "csv" }),
    },
    {
      key: "pdf",
      label: "Export as PDF",
      onClick: () => exportSelectedLoanTransactions({ format: "pdf" }),
    },
  ];

  const {
    mutate: exportLoanTransactions,
    isLoading: loadingExportLoanTransactions,
  } = useMutation({
    mutationKey: ["export all loan transactions"],
    mutationFn: ({ format }) =>
      exportAllLoanTransactions(
        id,
        format,
        fromDate,
        toDate,
        search,
        status,
        method,
        type,
      ),
    onSuccess: (blob, variables) => {
      downloadExportFile(blob, `Loan transactions.${variables.format}`);
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const {
    mutate: exportSelectedLoanTransactions,
    isLoading: loadingExportSelectedLoanTransactions,
  } = useMutation({
    mutationKey: ["export all selected loan transactions"],
    mutationFn: ({ format }) =>
      exportAllSelectedLoanTransactions(id, format, selectedTransactions),
    onSuccess: (blob, variables) => {
      downloadExportFile(blob, `Loans.${variables.format}`);
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const statusStyles = {
    pending: "bg-yellow-100 text-yellow-700",
    active: "bg-green-100 text-green-700",
    closed: "bg-blue-100 text-blue-700",
    declined: "bg-red-100 text-red-700",
  };
  const myStatus = loan?.status ?? "Pending";
  const styles = statusStyles[myStatus] || "bg-gray-100 text-gray-700";

  const [formData, setFormData] = useState({
    amount: "",
    date: "",
    method: "",
    reference: "",
    notes: "",
  });
  const [uploadedFile, setUploadedFile] = useState(null);
  const [openMakePaymentSuccess, setOpenMakePaymentSuccess] = useState(false);
  const [openManualPaymentPrompt, setOpenManualPaymentPrompt] = useState(false);

  const { mutate: makeManualPay, isLoading: loadingMakePayment } = useMutation({
    mutationKey: ["manual payments"],
    mutationFn: () =>
      makeManualPayment(
        id,
        formData?.amount,
        formData?.date,
        formData?.method,
        formData?.reference,
        formData?.notes,
        uploadedFile,
      ),
    onSuccess: () => {
      setFormData({
        amount: "",
        date: "",
        method: "",
        reference: "",
        notes: "",
      });
      setUploadedFile(null);
      refetchTransaction();
      refetchLoan();
      setOpenManualPaymentPrompt(false);
      setOpenMakePaymentSuccess(true);
    },
    onErrors: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const handleMakePayment = async () => {
    await makeManualPay();
  };
  return (
    <>
      {openMakePaymentSuccess && (
        <ManualPaymentSuccess
          closeManualPaymentSuccess={() => setOpenMakePaymentSuccess(false)}
        />
      )}
      {openManualPaymentPrompt && (
        <ManualPaymentPrompt
          closeManualPaymentPrompt={() => setOpenManualPaymentPrompt(false)}
          handleContinuePayment={handleMakePayment}
          loading={loadingMakePayment}
          amount={formData?.amount ?? 0}
        />
      )}
      {openManualTransaction && (
        <ManualTransaction
          closeManualTransaction={() => setOpenManualTransaction(false)}
          formData={formData}
          setFormData={setFormData}
          uploadedFile={uploadedFile}
          setUploadedFile={setUploadedFile}
          balance={loan?.balance ?? 0}
          handleContinue={() => {
            setOpenManualTransaction(false);
            setOpenManualPaymentPrompt(true);
          }}
        />
      )}
      {openLoanTransaction && (
        <LoanTransaction
          closeLoanTransaction={closeLoanTransaction}
          transaction={selectedLoanTransaction}
        />
      )}
      {openDisburseDetails && (
        <DisburseDetails
          closeDisburseDetails={closeDisburseDetails}
          handleChooseDisburseType={handleChooseDisburseType}
          loanApplication={loan?.loanApplication ?? {}}
          handleDeclineDisburse={handleDeclineDisburse}
        />
      )}

      {openTransactionFilter && (
        <TransactionFilter
          closeFilters={closeTransactionFilter}
          handleApplyFilter={closeTransactionFilter}
          status={status}
          setStatus={setStatus}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          type={type}
          setType={setType}
          method={method}
          setMethod={setMethod}
        />
      )}

      {openDisburseType && (
        <DisburseType
          closeDisburseType={closeDisburseType}
          handleChooseDisbursePhone={handleChooseDisbursePhone}
          handleAccountNumber={handleAccountNumber}
          disburseDetails={disburseDetails}
          setDisburseDetails={setDisburseDetails}
        />
      )}

      {openDisbursePhone && (
        <DisbursePhone
          closeDisbursePhone={closeDisbursePhone}
          handleReviewDisburseDetails={handleReviewDisburseDetails}
          disburseDetails={disburseDetails}
          setDisburseDetails={setDisburseDetails}
        />
      )}

      {openReviewDisburseDetails && (
        <ReviewDisburseDetails
          closeReviewDisburseDetails={closeReviewDisburseDetails}
          handleRecordDisbursement={handleRecordDisbursement}
          disburseDetails={disburseDetails}
          loanApplication={loan?.loanApplication ?? {}}
          loading={loadingDisbursement}
          setDisburseDetails={setDisburseDetails}
        />
      )}

      {openRecordBankTransaction && (
        <RecordBankTransaction
          closeRecordBankTransaction={closeRecordBankTransaction}
          handleDisburseSuccess={handleDisburseSuccess}
          disburseTransaction={disburseTransaction}
          setDisburseTransaction={setDisburseTransaction}
          loading={loadingDisbursementByBank}
        />
      )}

      {openDisburseSuccess && (
        <DisburseSuccess closeDisburseSuccess={closeDisburseSuccess} />
      )}

      {openDeclineDisburse && (
        <DeclineDisburse
          closeDeclineDisburse={closeDeclineDisburse}
          handleDeclineDisburseSuccess={handleDeclineDisburseSuccess}
          declineDisburseDetails={declineDisburseDetails}
          setDeclineDisburseDetails={setDeclineDisburseDetails}
          loading={loadingDeclineDisbursement}
        />
      )}

      {openDeclineDisburseSuccess && (
        <DeclineDisburseSuccess
          closeDeclineDisburseSuccess={closeDeclineDisburseSuccess}
        />
      )}

      {isLoading ? (
        <SingleLoanSkeleton />
      ) : (
        <div className="w-full pl-[10px]">
          <div className="flex items-center h-[50px] mb-[10px] justify-between">
            <div className="flex items-center gap-[5px]">
              <ChevronLeft color="#000000" size={17} />
              <span
                onClick={() => navigate("/dashboard/loans")}
                className="cursor-pointer"
              >
                Loans
              </span>
              <ChevronRight color="#000000" size={17} />
              <span className="underline font-bold text-[16px] text-[#222222]">
                {loan?.public_id}
              </span>
            </div>
            <div className="flex items-center gap-[10px]">
              <User color="#000000" size={16} />
              <span className="text-[#000000] text-[14px] font-normal">
                {loan?.loanApplication?.customer?.firstname}{" "}
                {loan?.loanApplication?.customer?.lastname}
              </span>
              <button
                className={`capitalize h-[40px] rounded-[30px] text-[14px] font-normal px-[20px] flex items-center justify-center ${styles}`}
              >
                <Circle size={17} className={`mr-1 ${styles}`} />
                {myStatus}
              </button>
            </div>
          </div>
          <div className="h-[180px] w-full bg-[#000000] mb-[10px] p-[15px] flex flex-col justify-between rounded-[10px] border border-[#FFDEDE]">
            <div className="flex items-center justify-between">
              <p className="text-[#F3F3F3] text-[16px] font-medium">
                {loan?.status === "awaiting disbursement"
                  ? "Potential Repayment Amount"
                  : "Balance"}
                (Ksh)
              </p>
              <div className="flex flex-col items-end">
                <p className="font-medium leading-none text-[12px] text-white">
                  Maturity
                </p>
                <p className="font-medium text-[14px] text-white">
                  {formattedDate(loan?.summary?.maturityDate)}
                </p>
              </div>
            </div>
            <p className="text-[40px] font-semibold text-[#F3F3F3]">
              {formatAmount(loan?.balance ?? 0)}
            </p>
            <div className="flex items-center justify-between">
              <div className="flex flex-col">
                <div className="flex items-center gap-[30px]">
                  <p className="font-medium text-[16px] text-[#F3F3F3]">
                    {loan?.summary?.percentPaid ?? 0}% Paid
                  </p>
                  <p className="font-medium text-[16px] text-[#F3F3F3]">
                    {formatAmount(loan?.summary?.totalPaid ?? 0)} /{" "}
                    {formatAmount(loan?.summary?.totalExpected ?? 0)}
                  </p>
                </div>
                <div className="w-full h-[10px] bg-[#DEFFF4] rounded-full overflow-hidden">
                  <div
                    className="h-full bg-[#00A676] rounded-full"
                    style={{
                      width: `${
                        loan?.summary?.totalExpected
                          ? Math.min(
                              (loan?.summary?.totalPaid /
                                loan?.summary?.totalExpected) *
                                100,
                              100,
                            )
                          : 0
                      }%`,
                    }}
                  ></div>
                </div>
              </div>
              <div className="flex flex-col items-end">
                <p className="font-medium leading-none text-[12px] text-white">
                  Next Payment
                </p>
                <p className="font-medium text-[14px] text-white">
                  {formattedDate(loan?.summary?.nextPayment?.dueDate)}
                </p>
              </div>
            </div>
          </div>
          {hasPermission(auth?.roles, "fb9240c3-e029-1796-295a-dfe13c38dccf") &&
            loan?.status === "awaiting disbursement" && (
              <div className="bg-[#DEFFF4] py-3 px-2 flex items-center justify-between rounded-md shadow">
                <div className="text-[#222222] text-justify w-[80%] font-normal space-y-2">
                  <p className="text-[15px] font-normal">
                    This loan is currently <strong>pending disbursement</strong>
                    . The committee has completed all necessary approvals, but
                    the funds have not yet been transferred.
                  </p>
                  <p className="text-[15px] font-normal">
                    Please review the loan details and ensure all
                    pre-disbursement checks have been completed before
                    proceeding. Once verified, you can disburse the loan using
                    the button on the right.
                  </p>
                  <p className="text-sm text-gray-600">
                    Note: Disbursing the loan will initiate the transfer of
                    funds to the borrower's account and cannot be undone.
                  </p>
                </div>
                <button
                  onClick={toggleDisburseDetails}
                  className="bg-[#000000] hover:bg-[#ffffff] hover:text-[#000000] text-white font-semibold py-2 px-[30px] rounded-[10px] shadow"
                >
                  Disburse
                </button>
              </div>
            )}
          <div className="h-[40px] flex justify-between my-[20px] w-full">
            {[
              "Loan Details",
              "Borrower",
              "Guarantors",
              "Loan Schedule",
              "Penalties",
              "Transactions",
              "Loan Officer",
              "Action",
            ].map((tab) => (
              <div
                key={tab}
                onClick={() => switchTab(tab)}
                className={tabClass(tab)}
              >
                {tab}
              </div>
            ))}
          </div>
          {activeTab === "Transactions" && (
            <>
              <div className="h-[35px] mb-[10px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                <p className="text-[#000000] font-medium text-[20px]">
                  Loan Transactions
                </p>
              </div>
              {loanTransactions?.length > 0 ? (
                <div>
                  <div className="h-[70px] w-full bg-white flex items-center justify-between px-[10px]">
                    <button
                      disabled={isRefetchingTransactions}
                      onClick={refetchTransaction}
                      className="h-[40px] w-[117px] flex items-center justify-center gap-[5px] border border-[#00A676] bg-white rounded-[10px] text-[#00A676] font-medium text-[15px]"
                    >
                      {isRefetchingTransactions ? (
                        <Loading />
                      ) : (
                        <Loader size={17} />
                      )}
                      Update
                    </button>
                    <div className="h-[40px] w-[117px] text-[#5C5C5C] font-medium text-[15px] rounded-[10px] border border-[#F3F3F3] bg-white flex items-center justify-center">
                      {selectedTransactions.length} Selected
                    </div>
                    <div
                      onClick={toggleTransactionFilter}
                      className="h-[40px] cursor-pointer w-[127px] text-[#5C5C5C] font-medium text-[15px] rounded-[10px] border border-[#F3F3F3] bg-[#FBF5F5] flex items-center justify-center gap-[5px]"
                    >
                      <SortAsc color="#000000" />
                      <span className="text-[#000000]">Filter</span>
                    </div>
                    <div className="flex items-center border border-gray-300 rounded-md px-3 h-[40px] w-[50%] bg-white">
                      <Search className="text-gray-500 w-5 h-5 mr-2" />
                      <input
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search loans, name, loan code..."
                        className="w-full outline-none text-sm text-gray-700 placeholder-gray-400 bg-transparent"
                      />
                    </div>
                    <p className="text-[#000000] truncate text-[15px] font-normal">
                      {loanTransactions?.length} Results
                    </p>
                    {selectedTransactions?.length === 0 ? (
                      <Dropdown
                        menu={{ items }}
                        trigger={["click"]}
                        placement="bottom"
                      >
                        <Button className="flex items-center bg-[#F3F3F3] border-[0.7px] border-[#A8A8A8] h-[40px] rounded-[30px] px-[20px] justify-center gap-[5px] text-[16px] text-[#5C5C5C]">
                          {loadingExportLoanTransactions ? (
                            <Loading />
                          ) : (
                            <LucideUpload size={17} />
                          )}
                          <span>Export</span>
                        </Button>
                      </Dropdown>
                    ) : (
                      <Dropdown
                        menu={{ items: selectedItems }}
                        trigger={["click"]}
                        placement="bottom"
                      >
                        <Button className="flex items-center bg-[#F3F3F3] border-[0.7px] border-[#A8A8A8] h-[40px] rounded-[30px] px-[20px] justify-center gap-[5px] text-[16px] text-[#5C5C5C]">
                          {loadingExportSelectedLoanTransactions ? (
                            <Loading />
                          ) : (
                            <LucideUpload size={17} />
                          )}
                          <span>Export</span>
                        </Button>
                      </Dropdown>
                    )}
                  </div>
                  <div>
                    <div className="h-[44px] px-[10px] w-full bg-[#F3F3F3] mb-[10px] flex items-center">
                      <div className="w-[5%]">
                        <input
                          type="checkbox"
                          checked={
                            loanTransactions.length > 0 &&
                            selectedTransactions.length ===
                              loanTransactions.length
                          }
                          onChange={handleSelectAll}
                        />
                      </div>
                      <div className="w-[7%] text-[#000] truncate font-medium text-[14px]">
                        ID
                      </div>
                      <div className="w-[14%] text-[#000] font-medium text-[14px]">
                        SENDER INFO
                      </div>
                      <div className="w-[8%] text-[#000] font-medium text-[14px]">
                        TYPE
                      </div>
                      <div className="w-[8%] text-[#000] font-medium text-[14px]">
                        MODE
                      </div>
                      <div className="w-[15%] text-[#000] font-medium text-[14px]">
                        REFERENCE
                      </div>
                      <div className="w-[12%] text-[#000] font-medium text-[14px]">
                        AMOUNT
                      </div>
                      <div className="w-[12%] text-[#000] font-medium text-[14px]">
                        BALANCE
                      </div>
                      <div className="w-[13%] text-[#000] font-medium text-[14px]">
                        DATE
                      </div>
                      <div className="w-[10%] text-[#000] font-medium text-[14px]">
                        STATUS
                      </div>
                    </div>
                    {loanTransactions?.length > 0 &&
                      loanTransactions.map((txn) => (
                        <div
                          key={txn.id}
                          className="h-[40px] px-[10px] w-full bg-white mb-[7px] flex items-center"
                        >
                          <div className="w-[5%]">
                            <input
                              type="checkbox"
                              checked={selectedTransactions.includes(txn.id)}
                              onChange={() => handleSelectTransaction(txn.id)}
                            />
                          </div>
                          <div
                            onClick={() => toggleLoanTransaction(txn)}
                            className="w-[7%] text-[#2A8C52] truncate cursor-pointer font-normal text-sm"
                          >
                            {txn?.public_id ?? "LN100"}
                          </div>
                          <div className="w-[14%] capitalize text-[#000] font-normal text-sm">
                            {txn?.senderName ?? "JOHN OTIENO"}
                          </div>
                          <div className="w-[8%] capitalize text-[#000] font-normal text-sm">
                            {txn?.category}
                          </div>
                          <div className="w-[8%] capitalize text-[#000] font-normal text-sm">
                            {txn?.method}
                          </div>
                          <div className="w-[15%] truncate text-[#000] font-normal text-sm">
                            {txn?.paymentReference.length > 0
                              ? txn?.paymentReference
                              : txn?.method}
                          </div>
                          <div className="w-[12%] text-[#000] font-normal text-sm">
                            {formatAmount(txn?.amount ?? 0)}
                          </div>
                          <div className="w-[12%] text-[#000] font-normal text-sm">
                            {formatAmount(txn?.balance ?? 0)}
                          </div>
                          <div className="w-[13%] text-[#000] font-normal text-sm">
                            {formattedDate(txn?.paymentDate)}
                          </div>
                          <div className="w-[10%] text-sm font-normal flex items-center gap-2">
                            {getStatusIcon(txn?.status)}
                            <span className="capitalize">{txn?.status}</span>
                          </div>
                        </div>
                      ))}
                  </div>
                  <div className="h-[50px] mb-[20px] flex items-center justify-between">
                    <div className="flex items-center gap-[10px]">
                      <p className="text-[15px] text-[#5C5C5C] font-normal">
                        {start}–{end} of {totalItems}
                      </p>
                      <p className="text-[15px] text-[#5C5C5C] font-normal">
                        Row/Page:
                      </p>
                      <p className="text-[15px] text-[#5C5C5C] font-normal">
                        {page}/{totalPages}
                      </p>
                      <select
                        className="h-[35px] w-[100px] px-[10px] text-[12px]"
                        name="row"
                        id="row"
                        value={limit}
                        onChange={(e) => setLimit(e.target.value)}
                      >
                        <option value="10">10 items</option>
                        <option value="20">20 items</option>
                        <option value="25">25 items</option>
                      </select>
                    </div>
                    <div>
                      <Pagination
                        currentPage={page}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="my-[20px] flex items-center gap-[10px]">
                  <Info size={17} />
                  <p>No loan transactions are available</p>
                </div>
              )}
            </>
          )}
          {activeTab === "Borrower" && (
            <>
              <div>
                {loan?.loanApplication?.customer?.selfie_image?.length > 0 && (
                  <div className="w-[90px] h-[90px] my-[10px] rounded-[20px] flex items-center justify-center">
                    <img
                      className="h-full w-full rounded-[20px] object-cover"
                      src={loan?.loanApplication?.customer?.selfie_image}
                      alt="user"
                    />
                  </div>
                )}
                <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                  <p className="text-[#000000] font-medium text-[20px]">
                    Personal Details
                  </p>
                  {/* <p className="text-[#037BD1] text-[14px] font-medium">Edit</p> */}
                </div>
                <div className="flex items-center justify-between my-[10px]">
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      ID Number
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.identification ?? "N/A"
                      }
                    />
                  </div>
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      First Name
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.firstname ?? "N/A"
                      }
                    />
                  </div>
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Middle Name
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.middlename ?? "N/A"
                      }
                    />
                  </div>
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Last Name
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.lastname ?? "N/A"
                      }
                    />
                  </div>
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Date of Birth
                    </p>
                    <DataCard
                      width="full"
                      myData={loan?.loanApplication?.customer?.dob ?? "N/A"}
                    />
                  </div>
                </div>
                <div className="flex items-center justify-between my-[20px]">
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Gender
                    </p>
                    <DataCard
                      width="full"
                      myData={loan?.loanApplication?.customer?.gender ?? "N/A"}
                    />
                  </div>
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Phone Number
                    </p>
                    <CopyDataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.mobileno ?? "N/A"
                      }
                    />
                  </div>
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Alt Phone Number
                    </p>
                    <CopyDataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.altPhoneNumber ?? "N/A"
                      }
                    />
                  </div>
                  <div className="flex flex-col w-[39%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Email
                    </p>
                    <CopyDataCard
                      width="full"
                      myData={loan?.loanApplication?.customer?.email ?? "N/A"}
                    />
                  </div>
                </div>
                <div className="flex items-center gap-[1.25%] my-[20px]">
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Marital Status
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.maritalStatus ?? "N/A"
                      }
                    />
                  </div>
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Number of Dependants
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.dependants ?? "N/A"
                      }
                    />
                  </div>
                  <div className="flex flex-col w-[39%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      P.O Box
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.postal_address ?? "N/A"
                      }
                    />
                  </div>
                </div>

                {/* next of kin */}
                <div className="h-[35px] mt-[10px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                  <p className="text-[#000000] font-medium text-[20px]">
                    Next of Kin Details
                  </p>
                </div>
                <div className="flex items-center justify-between my-[10px]">
                  <div className="flex flex-col w-[39%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Full Name
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.nextOfKins?.[0]
                          ?.name ?? "N/A"
                      }
                    />
                  </div>
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Relationship
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.nextOfKins?.[0]
                          ?.relationship ?? "N/A"
                      }
                    />
                  </div>
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Phone Number
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.nextOfKins?.[0]
                          ?.phoneNumber ?? "N/A"
                      }
                    />
                  </div>
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Residence
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.nextOfKins?.[0]
                          ?.location ?? "N/A"
                      }
                    />
                  </div>
                </div>
                <div className="flex items-center justify-between my-[10px]">
                  <div className="flex flex-col w-[19%]">
                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                      Nearest Landmark
                    </p>
                    <DataCard
                      width="full"
                      myData={
                        loan?.loanApplication?.customer?.nextOfKins?.[0]
                          ?.location ?? "N/A"
                      }
                    />
                  </div>
                </div>

                {/* income */}
                <div className="my-[30px] w-full">
                  <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                    <p className="text-[#000000] font-medium text-[20px]">
                      Income Details
                    </p>
                  </div>

                  {/* Row 1 */}
                  <div className="flex items-center justify-between my-[10px]">
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Source of Income
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.sourceOfIncome ?? "N/A"
                        }
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        KRA PIN
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.businessKraPin ?? "N/A"
                        }
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Business Name
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.businessName ?? "N/A"
                        }
                      />
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="flex items-center justify-between my-[10px]">
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Years of Operation
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.yearsOfOperation ?? "N/A"
                        }
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Business Ownership
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.businessOwnership ?? "N/A"
                        }
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Business License
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.businessLicense ?? "N/A"
                        }
                      />
                    </div>
                  </div>

                  {/* Row 3 */}
                  <div className="flex items-center justify-between my-[10px]">
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Employer Name
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.employerName ?? "N/A"
                        }
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Monthly Income
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.monthlyIncome ?? "N/A"
                        }
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Duration at Employer
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.durationAtEmployer ?? "N/A"
                        }
                      />
                    </div>
                  </div>

                  {/* Row 4 */}
                  <div className="flex items-center justify-between my-[10px]">
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Type of Business
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.typeOfBusiness ?? "N/A"
                        }
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Level of Stability
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.levelOfStability ?? "N/A"
                        }
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Risks Associated
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.risksAssociated ?? "N/A"
                        }
                      />
                    </div>
                  </div>

                  {/* Row 5 */}
                  <div className="flex items-center justify-between my-[10px]">
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Strength of Business
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.incomes?.[0]
                            ?.strengthOfBusiness ?? "N/A"
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Business location */}
                <div className="my-[30px] w-full">
                  <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                    <p className="text-[#000000] font-medium text-[20px]">
                      Business Location
                    </p>
                  </div>
                  <div className="flex items-center justify-between my-[10px]">
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Latitude & Longitude
                      </p>
                      <CopyDataLocation
                        width="full"
                        myData={`${decimalToDMS(
                          loan?.loanApplication?.customer?.businesses?.[0]
                            ?.businessLatitude,
                          true,
                        )} ${decimalToDMS(
                          loan?.loanApplication?.customer?.businesses?.[0]
                            ?.businessLongitude,
                          false,
                        )}`}
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Physical Address
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.businesses?.[0]?.businessPhysicalAddress?.trim() ||
                          "N/A"
                        }
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Location Description
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.businesses?.[0]?.businessLocationDescription?.trim() ||
                          "N/A"
                        }
                      />
                    </div>
                  </div>
                  {loan?.loanApplication?.customer?.businesses?.[0]
                    ?.businessImageUrl && (
                    <div className="w-[32%] h-[150px] my-[20px] rounded-[10px] bg-white">
                      <img
                        className="h-full w-full object-cover rounded-[10px]"
                        src={
                          loan?.loanApplication.customer.businesses[0]
                            .businessImageUrl
                        }
                        alt="business location"
                      />
                    </div>
                  )}
                </div>

                {/* Residence location */}
                <div className="my-[30px] w-full">
                  <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                    <p className="text-[#000000] font-medium text-[20px]">
                      Residential Location
                    </p>
                  </div>
                  <div className="flex items-center justify-between my-[10px]">
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Latitude & Longitude
                      </p>
                      <CopyDataLocation
                        width="full"
                        myData={`${decimalToDMS(
                          loan?.loanApplication?.customer?.residences?.[0]
                            ?.residenceLatitude,
                          true,
                        )} ${decimalToDMS(
                          loan?.loanApplication?.customer?.residences?.[0]
                            ?.residenceLongitude,
                          false,
                        )}`}
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Physical Address
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.residences?.[0]
                            ?.residencePhysicalAddress
                        }
                      />
                    </div>
                    <div className="flex flex-col w-[32%]">
                      <p className="text-[#5C5C5C] text-[14px] font-medium">
                        Location Description
                      </p>
                      <DataCard
                        width="full"
                        myData={
                          loan?.loanApplication?.customer?.residences?.[0]
                            ?.residenceLocationDescription
                        }
                      />
                    </div>
                  </div>
                  {loan?.loanApplication?.customer?.residences?.[0]
                    ?.residenceImageUrl && (
                    <div className="w-[32%] h-[150px] my-[20px] rounded-[10px] bg-white">
                      <img
                        className="h-full w-full object-cover rounded-[10px]"
                        src={
                          loan?.loanApplication.customer.residences[0]
                            .residenceImageUrl
                        }
                        alt="business location"
                      />
                    </div>
                  )}
                </div>

                {/* Borrower docs */}
                <div className="my-[20px] w-full">
                  <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                    <p className="text-[#000000] font-medium text-[20px]">
                      Borrower’s Documents
                    </p>
                  </div>
                  <div className="h-[40px] bg-[#F3F3F3] my-[10px] pl-[10px] flex items-center">
                    <div className="w-[20%] text-[14px] text-[#222222]">ID</div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      UPDATED
                    </div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      NAME
                    </div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      STATUS
                    </div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      DOWNLOAD
                    </div>
                  </div>
                  {loan?.loanApplication?.customer?.id_front_image?.length >
                    0 && (
                    <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                      <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                        {loan?.loanApplication?.loanCode?.slice(0, 7)}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                        {formattedDate(
                          loan?.loanApplication?.customer?.updatedAt,
                        )}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Id front image
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Active
                      </div>
                      <div className="w-[20%] flex gap-4 items-center text-[#222222]">
                        <Download
                          onClick={() =>
                            downloadFromUrl(
                              loan?.loanApplication?.customer?.id_front_image,
                              "id_front_image",
                            )
                          }
                          color="#000000"
                          className="w-5 h-5 cursor-pointer hover:scale-110 transition"
                        />
                      </div>
                    </div>
                  )}
                  {loan?.loanApplication?.customer?.id_back_image?.length >
                    0 && (
                    <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                      <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                        {loan?.loanApplication?.loanCode?.slice(0, 7)}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                        {formattedDate(
                          loan?.loanApplication?.customer?.updatedAt,
                        )}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Id Back image
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Active
                      </div>
                      <div className="w-[20%] flex gap-4 items-center text-[#222222]">
                        <Download
                          onClick={() =>
                            downloadFromUrl(
                              loan?.loanApplication?.customer?.id_back_image,
                              "id_back_image",
                            )
                          }
                          color="#000000"
                          className="w-5 h-5 cursor-pointer hover:scale-110 transition"
                        />
                      </div>
                    </div>
                  )}
                  {loan?.loanApplication?.customer?.passport_image?.length >
                    0 && (
                    <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                      <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                        {loan?.loanApplication?.loanCode?.slice(0, 7)}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                        {formattedDate(
                          loan?.loanApplication?.customer?.updatedAt,
                        )}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Passport id image
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Active
                      </div>
                      <div className="w-[20%] flex gap-4 items-center text-[#222222]">
                        <Download
                          onClick={() =>
                            downloadFromUrl(
                              loan?.loanApplication?.customer?.passport_image,
                              "passport_image",
                            )
                          }
                          color="#000000"
                          className="w-5 h-5 cursor-pointer hover:scale-110 transition"
                        />
                      </div>
                    </div>
                  )}
                  {loan?.loanApplication?.customer?.signatureUrl?.length >
                    0 && (
                    <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                      <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                        {loan?.loanApplication?.loanCode?.slice(0, 7)}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                        {formattedDate(
                          loan?.loanApplication?.customer?.updatedAt,
                        )}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Signature image
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Active
                      </div>
                      <div className="w-[20%] flex gap-4 items-center text-[#222222]">
                        <Download
                          onClick={() =>
                            downloadFromUrl(
                              loan?.loanApplication?.customer?.signatureUrl,
                              "signature",
                            )
                          }
                          color="#000000"
                          className="w-5 h-5 cursor-pointer hover:scale-110 transition"
                        />
                      </div>
                    </div>
                  )}
                  {loan?.loanApplication?.documents?.length > 0 ? (
                    loan?.loanApplication?.documents.map((doc) => (
                      <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                        <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                          {doc?.id?.slice(0, 7)}
                        </div>
                        <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                          {formattedDate(doc?.uploadedAt)}
                        </div>
                        <div className="w-[20%] capitalize text-[14px] text-[#00A676] font-normal">
                          {doc?.documentName}
                        </div>
                        <div className="w-[20%] capitalize text-[14px] text-[#00A676] font-normal">
                          {doc?.status}
                        </div>
                        <div className="w-[20%] flex gap-4 items-center text-[#222222]">
                          <Download
                            onClick={() =>
                              downloadFromUrl(doc?.fileUrl, doc?.documentName)
                            }
                            color="#000000"
                            className="w-5 h-5 cursor-pointer hover:scale-110 transition"
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="flex items-center gap-2 text-gray-500 mt-4">
                      <InfoIcon className="w-5 h-5 text-gray-400" />
                      <span>No other borrower document available</span>
                    </div>
                  )}
                </div>

                {/* chattels */}
                <div className="my-[20px] w-full">
                  <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                    <p className="text-[#000000] font-medium text-[20px]">
                      Chattels
                    </p>
                  </div>
                  <div className="h-[40px] bg-[#F3F3F3] my-[10px] pl-[10px] flex items-center">
                    <div className="w-[20%] flex items-center gap-[5px]">
                      <p className="text-[14px] text-[#222222] font-normal">
                        ID
                      </p>
                    </div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      UPDATED
                    </div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      NAME
                    </div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      CHATTEL LOCATION
                    </div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      DOWNLOAD
                    </div>
                  </div>
                  {loan?.loanApplication?.customer?.chattels?.length > 0 ? (
                    loan?.loanApplication?.customer?.chattels?.map((item) => (
                      <div
                        key={item.id}
                        className="h-[35px] my-[10px] pl-[10px] flex items-center"
                      >
                        <div className="w-[20%] flex items-center gap-[5px]">
                          <p className="text-[14px] text-[#222222] font-normal">
                            {item?.id?.substring(0, 6)}
                          </p>
                        </div>
                        <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                          {formattedDate(item.updatedAt)}
                        </div>
                        <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                          {item.name}
                        </div>
                        <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                          {item.location}
                        </div>
                        <div className="w-[20%] flex gap-4 items-center text-[#222222]">
                          <Download
                            onClick={() => {
                              console.log("first");
                              downloadFromUrl(item?.images, item?.name);
                            }}
                            color="#000000"
                            className="w-5 h-5 cursor-pointer hover:scale-110 transition"
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="flex items-center gap-2 text-gray-500 mt-4">
                      <InfoIcon className="w-5 h-5 text-gray-400" />
                      <span>No chattel data available</span>
                    </div>
                  )}
                </div>

                {/* docs status */}
                <div className="my-[20px] w-full">
                  <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                    <p className="text-[#000000] font-medium text-[20px]">
                      Loan Document(s) Status
                    </p>
                  </div>
                  <div className="h-[40px] bg-[#F3F3F3] my-[10px] pl-[10px] flex items-center">
                    <div className="w-[20%] flex items-center gap-[5px]">
                      <p className="text-[14px] font-normal">ID</p>
                    </div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      UPDATED AT
                    </div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      FILENAME
                    </div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      UPLOAD STATUS
                    </div>
                    <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                      SIGNATURE STATUS
                    </div>
                  </div>
                  {loan?.loanApplication?.customer?.id_front_image?.length >
                    0 && (
                    <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                      <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                        {loan?.loanApplication?.loanCode?.slice(0, 7)}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                        {formattedDate(
                          loan?.loanApplication?.customer?.updatedAt,
                        )}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Id front image
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Active
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal flex items-center gap-2">
                        <CheckCircle className="text-green-600 w-5 h-5" />
                        <span className="text-green-700">Signed</span>
                      </div>
                    </div>
                  )}
                  {loan?.loanApplication?.customer?.id_front_image?.length >
                    0 && (
                    <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                      <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                        {loan?.loanApplication?.loanCode?.slice(0, 7)}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                        {formattedDate(
                          loan?.loanApplication?.customer?.updatedAt,
                        )}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Id Back image
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Active
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal flex items-center gap-2">
                        <CheckCircle className="text-green-600 w-5 h-5" />
                        <span className="text-green-700">Signed</span>
                      </div>
                    </div>
                  )}
                  {loan?.loanApplication?.customer?.passport_image?.length >
                    0 && (
                    <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                      <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                        {loan?.loanApplication?.loanCode?.slice(0, 7)}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                        {formattedDate(
                          loan?.loanApplication?.customer?.updatedAt,
                        )}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Passport id image
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Active
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal flex items-center gap-2">
                        <CheckCircle className="text-green-600 w-5 h-5" />
                        <span className="text-green-700">Signed</span>
                      </div>
                    </div>
                  )}
                  {loan?.loanApplication?.customer?.signatureUrl?.length >
                    0 && (
                    <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                      <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                        {loan?.loanApplication?.loanCode?.slice(0, 7)}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                        {formattedDate(
                          loan?.loanApplication?.customer?.updatedAt,
                        )}
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Signature image
                      </div>
                      <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                        Active
                      </div>
                      <div className="w-[20%] text-[14px] text-[#222222] font-normal flex items-center gap-2">
                        <CheckCircle className="text-green-600 w-5 h-5" />
                        <span className="text-green-700">Signed</span>
                      </div>
                    </div>
                  )}
                  {loan?.loanApplication?.documents?.length > 0 ? (
                    loan?.loanApplication?.documents.map((doc) => (
                      <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                        <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                          {doc?.id?.slice(0, 7)}
                        </div>
                        <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                          {formattedDate(doc?.uploadedAt)}
                        </div>
                        <div className="w-[20%] capitalize text-[14px] text-[#00A676] font-normal">
                          {doc?.documentName}
                        </div>
                        <div className="w-[20%] capitalize text-[14px] text-[#00A676] font-normal">
                          Active
                        </div>
                        <div className="w-[20%] text-[14px] text-[#222222] font-normal flex items-center gap-2">
                          <CheckCircle className="text-green-600 w-5 h-5" />
                          <span className="text-green-700">Signed</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="flex items-center gap-2 text-gray-500 mt-4">
                      <InfoIcon className="w-5 h-5 text-gray-400" />
                      <span>No other borrower document available</span>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {activeTab === "Loan Details" && (
            <>
              <div className="h-[35px] mb-[10px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                <p className="text-[#000000] font-medium text-[20px]">
                  Loan Details
                </p>
              </div>
              <div className="flex my-[20px] flex-wrap gap-[20px]">
                {/* Loan Code */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Loan Code
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(loan?.public_id)}
                  />
                </div>

                {/* Loan Amount */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Loan Amount
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      formatAmount(loan?.loanApplication?.loanAmount),
                    )}
                  />
                </div>

                {/* Interest Rate */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Interest Rate
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(loan?.loanApplication?.interestRate)}
                  />
                </div>

                {/* Loan Period */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Loan Period
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(loan?.loanApplication?.loanPeriod)}
                  />
                </div>

                {/* Repayment Amount */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Repayment Amount
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      formatAmount(loan?.loanApplication?.repaymentAmount),
                    )}
                  />
                </div>

                {/* Status */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Status
                  </p>
                  <DataCard width="full" myData={formatValue(loan?.status)} />
                </div>

                {/* Created At */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Created At
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      formattedDate(loan?.loanApplication?.createdAt),
                    )}
                  />
                </div>

                {/* Updated At */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Updated At
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      formattedDate(loan?.loanApplication?.updatedAt),
                    )}
                  />
                </div>

                {/* Submitted At */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Submitted At
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(loan?.loanApplication?.submittedAt)}
                  />
                </div>

                {/* Approved At */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Approved At
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      formattedDate(loan?.loanApplication?.approvedAt),
                    )}
                  />
                </div>

                {/* Repayment Frequency */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Repayment Frequency
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      loan?.loanApplication?.repaymentFrequency,
                    )}
                  />
                </div>

                {/* Grace Period */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Grace Period
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(loan?.loanApplication?.gracePeriod)}
                  />
                </div>

                {/* Source */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Source
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(loan?.loanApplication?.source)}
                  />
                </div>

                {/* Loan Purpose */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Loan Purpose
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(loan?.loanApplication?.loanPurpose)}
                  />
                </div>

                {/* Application Stage */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Application Stage
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      loan?.loanApplication?.application_stage,
                    )}
                  />
                </div>
              </div>
            </>
          )}
          {activeTab === "Loan Officer" && (
            <div>
              <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                <p className="text-[#000000] font-medium text-[20px]">
                  Loan Officer
                </p>
              </div>
              <div className="flex my-[20px] flex-wrap gap-[20px]">
                {/* Public ID */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Public ID
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      loan?.loanApplication?.loanOfficer?.public_id,
                    )}
                  />
                </div>
                {/* First Name */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    First Name
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      loan?.loanApplication?.loanOfficer?.firstname,
                    )}
                  />
                </div>
                {/* Last Name */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Last Name
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      loan?.loanApplication?.loanOfficer?.lastname,
                    )}
                  />
                </div>
                {/* Phone */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Phone
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      loan?.loanApplication?.loanOfficer?.phone,
                    )}
                  />
                </div>
                {/* Email */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Email
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      loan?.loanApplication?.loanOfficer?.email,
                    )}
                  />
                </div>
                {/* Status */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Status
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      loan?.loanApplication?.loanOfficer?.status,
                    )}
                  />
                </div>
                {/* Country */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Country
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      loan?.loanApplication?.loanOfficer?.country,
                    )}
                  />
                </div>
                {/* Department */}
                <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                  <p className="text-[#5C5C5C] text-[14px] font-medium">
                    Department
                  </p>
                  <DataCard
                    width="full"
                    myData={formatValue(
                      loan?.loanApplication?.loanOfficer?.department,
                    )}
                  />
                </div>
              </div>
            </div>
          )}
          {activeTab === "Guarantors" && (
            <>
              <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                <p className="text-[#000000] font-medium text-[20px]">
                  Guarantors
                </p>
              </div>
              <div className="my-[10px] w-full">
                {loan?.loanApplication?.guarantors &&
                loan?.loanApplication.guarantors.length > 0 ? (
                  loan?.loanApplication.guarantors.map((guarantor, index) => {
                    const isOpen = openIndexes.includes(index);
                    return (
                      <div
                        key={index}
                        className="w-full mb-[10px] rounded-[8px]"
                      >
                        <div
                          className="h-[60px] px-[10px] bg-white w-full flex items-center justify-between cursor-pointer"
                          onClick={() => toggleGuarantor(index)}
                        >
                          <div>
                            <p className="text-gray-400 text-[14px] font-medium">
                              Guarantor {index + 1}
                            </p>
                            <p className="text-[#000000] text-[16px] font-medium">
                              {guarantor?.guarantorName ?? "N/A"}
                            </p>
                          </div>
                          <div className="flex items-center gap-[10px]">
                            <ChevronRight
                              color="#000000"
                              size={23}
                              className={`transition-transform duration-300 ${
                                isOpen ? "rotate-90" : ""
                              }`}
                            />
                          </div>
                        </div>

                        {/* Expandable content */}
                        {isOpen && (
                          <div className="w-full h-full bg-[#FEF9F9]">
                            <div className="px-[10px] w-full bg-white">
                              <div className="mb-[30px] w-full">
                                <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                                  <p className="text-[#000000] font-medium text-[20px]">
                                    Guarantor Details
                                  </p>
                                </div>
                                {guarantor?.guarantorPhoto?.trim()?.length >
                                  0 && (
                                  <div className="w-full h-[180px] my-[20px]">
                                    <p className="text-[#000000] font-medium text-[20px]">
                                      Guarantor Photo
                                    </p>
                                    <div className="h-[150px] w-[200px] rounded-[20px]">
                                      <img
                                        className="h-full w-full rounded-[20px] object-cover"
                                        src={guarantor?.guarantorPhoto}
                                        alt="guarantor-photo"
                                      />
                                    </div>
                                  </div>
                                )}
                                <div className="flex items-center justify-between my-[10px]">
                                  <div className="flex flex-col w-[32%]">
                                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                                      Name
                                    </p>
                                    <DataCard
                                      width="full"
                                      myData={guarantor?.guarantorName ?? "N/A"}
                                    />
                                  </div>
                                  <div className="flex flex-col w-[32%]">
                                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                                      Residence
                                    </p>
                                    <DataCard
                                      width="full"
                                      myData={
                                        guarantor?.residenceVillage ?? "N/A"
                                      }
                                    />
                                  </div>
                                  <div className="flex flex-col w-[32%]">
                                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                                      Phone number
                                    </p>
                                    <DataCard
                                      width="full"
                                      myData={
                                        guarantor?.guarantorPhone ?? "N/A"
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="flex items-center gap-[2%] my-[10px]">
                                  <div className="flex flex-col w-[32%]">
                                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                                      Email
                                    </p>
                                    <DataCard
                                      width="full"
                                      myData={
                                        guarantor?.guarantorEmail ?? "N/A"
                                      }
                                    />
                                  </div>
                                  <div className="flex flex-col w-[32%]">
                                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                                      Guarantee Amount
                                    </p>
                                    <DataCard
                                      width="full"
                                      myData={guarantor?.guaranteeAmount ?? 0}
                                    />
                                  </div>
                                  <div className="flex flex-col w-[32%]">
                                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                                      Guarantee Reason
                                    </p>
                                    <DataCard
                                      width="full"
                                      myData={guarantor?.reason ?? 0}
                                    />
                                  </div>
                                </div>
                                <div className="flex items-center gap-[2%] my-[10px]">
                                  <div className="flex flex-col w-[32%]">
                                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                                      Date
                                    </p>
                                    <DataCard
                                      width="full"
                                      myData={
                                        formattedDate(guarantor?.createdAt) ??
                                        "N/A"
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              {/* location */}
                              <div className="my-[30px] w-full">
                                <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                                  <p className="text-[#000000] font-medium text-[20px]">
                                    Guarantor Location
                                  </p>
                                </div>
                                <div className="flex items-center justify-between my-[10px]">
                                  <div className="flex flex-col w-[32%]">
                                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                                      Latitude & Longitude
                                    </p>
                                    <CopyDataLocation
                                      width="full"
                                      myData={`${decimalToDMS(
                                        guarantor?.residenceLatitude,
                                        true,
                                      )} ${decimalToDMS(
                                        guarantor?.residenceLongitude,
                                        false,
                                      )}`}
                                    />
                                  </div>
                                  <div className="flex flex-col w-[32%]">
                                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                                      Physical Address
                                    </p>
                                    <DataCard
                                      width="full"
                                      myData={
                                        guarantor?.residenceLocation?.trim() ||
                                        "N/A"
                                      }
                                    />
                                  </div>
                                  <div className="flex flex-col w-[32%]">
                                    <p className="text-[#5C5C5C] text-[14px] font-medium">
                                      Location Description
                                    </p>
                                    <DataCard
                                      width="full"
                                      myData={
                                        guarantor?.residenceLocation?.trim() ||
                                        "N/A"
                                      }
                                    />
                                  </div>
                                </div>
                                {guarantor?.guarantorBusinessPhoto && (
                                  <div className="w-[32%] h-[150px] my-[20px] rounded-[10px] bg-white">
                                    <img
                                      className="h-full w-full object-cover rounded-[10px]"
                                      src={guarantor?.guarantorBusinessPhoto}
                                      alt="business location"
                                    />
                                  </div>
                                )}
                              </div>
                              {/* chattels */}
                              <div className="my-[20px] w-full">
                                <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                                  <p className="text-[#000000] font-medium text-[20px]">
                                    Guarantor Chattels
                                  </p>
                                </div>
                                <div className="h-[40px] bg-[#F3F3F3] my-[10px] pl-[10px] flex items-center">
                                  <div className="w-[20%] flex items-center gap-[5px]">
                                    <input
                                      type="checkbox"
                                      name="doc"
                                      id="doc"
                                    />
                                    <p className="text-[14px] text-[#222222] font-normal">
                                      ID
                                    </p>
                                  </div>
                                  <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                    UPDATED
                                  </div>
                                  <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                    NAME
                                  </div>
                                  <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                    CHATTEL LOCATION
                                  </div>
                                  <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                    DOWNLOAD
                                  </div>
                                </div>
                                {guarantor?.chattels?.length > 0 ? (
                                  guarantor?.chattels?.map((item) => (
                                    <div
                                      key={item?.id}
                                      className="h-[35px] my-[10px] pl-[10px] flex items-center"
                                    >
                                      <div className="w-[20%] flex items-center gap-[5px]">
                                        <input
                                          type="checkbox"
                                          name={`chattel-${item?.id}`}
                                          id={`chattel-${item?.id}`}
                                        />
                                        <p className="text-[14px] text-[#222222] font-normal">
                                          {item?.id?.substring(0, 6)}
                                        </p>
                                      </div>
                                      <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                        {formattedDate(item?.updatedAt)}
                                      </div>
                                      <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                        {item?.name}
                                      </div>
                                      <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                        {item?.location}
                                      </div>
                                      <div className="w-[20%] flex gap-4 items-center text-[#222222]">
                                        <Download
                                          onClick={() =>
                                            downloadFromUrl(
                                              item?.images,
                                              "chattel_images",
                                            )
                                          }
                                          color="#000000"
                                          className="w-5 h-5 cursor-pointer hover:scale-110 transition"
                                        />
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="my-[20px] w-full flex items-center gap-[10px]">
                                    <Info size={16} />
                                    <p>No guarantor chattel available</p>
                                  </div>
                                )}
                              </div>
                              {/* docs */}
                              <div className="my-[20px] w-full">
                                <div className="h-[35px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                                  <p className="text-[#000000] font-medium text-[20px]">
                                    Guarantor’s Documents
                                  </p>
                                </div>
                                <div className="h-[40px] bg-[#F3F3F3] my-[10px] pl-[10px] flex items-center">
                                  <div className="w-[20%] flex items-center gap-[5px]">
                                    <input
                                      type="checkbox"
                                      name="doc"
                                      id="doc"
                                    />
                                    <p className="text-[14px] text-[#222222] font-normal">
                                      ID
                                    </p>
                                  </div>
                                  <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                    UPDATED
                                  </div>
                                  <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                    NAME
                                  </div>
                                  <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                    STATUS
                                  </div>
                                  <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                    DOWNLOAD
                                  </div>
                                </div>
                                {guarantor?.signatureUrl?.trim()?.length ===
                                  0 ||
                                (guarantor?.signatureUrl === null &&
                                  guarantor?.guarantorBusinessPhoto?.trim()
                                    ?.length === 0) ||
                                guarantor?.guarantorBusinessPhoto === null ? (
                                  <div className="my-[20px] w-full flex items-center gap-[10px]">
                                    <Info size={16} />
                                    <p>No guarantor docs available</p>
                                  </div>
                                ) : (
                                  <>
                                    {guarantor?.signatureUrl?.length > 0 && (
                                      <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                                        <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                                          <input
                                            type="checkbox"
                                            name="doc-1"
                                            id="doc-1"
                                          />
                                          {loan?.loanApplication?.loanCode?.slice(
                                            0,
                                            7,
                                          )}
                                        </div>
                                        <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                          {formattedDate(guarantor.createdAt)}
                                        </div>
                                        <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                                          Guarantor Signature
                                        </div>
                                        <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                                          Active
                                        </div>
                                        <div className="w-[20%] flex gap-4 items-center text-[#222222]">
                                          <Download
                                            onClick={() =>
                                              downloadFromUrl(
                                                guarantor?.signatureUrl,
                                                "guarantor-signature",
                                              )
                                            }
                                            color="#000000"
                                            className="w-5 h-5 cursor-pointer hover:scale-110 transition"
                                          />
                                        </div>
                                      </div>
                                    )}

                                    {guarantor?.guarantorBusinessPhoto?.length >
                                      0 && (
                                      <div className="h-[35px] my-[10px] pl-[10px] flex items-center">
                                        <div className="w-[20%] text-[14px] flex items-center gap-[5px]">
                                          <input
                                            type="checkbox"
                                            name="doc-2"
                                            id="doc-2"
                                          />
                                          {loan?.loanApplication?.loanCode?.slice(
                                            0,
                                            7,
                                          )}
                                        </div>
                                        <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                                          {formattedDate(guarantor.createdAt)}
                                        </div>
                                        <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                                          Guarantor Business Photo
                                        </div>
                                        <div className="w-[20%] text-[14px] text-[#00A676] font-normal">
                                          Active
                                        </div>
                                        <div className="w-[20%] flex gap-4 items-center text-[#222222]">
                                          <Download
                                            onClick={() =>
                                              downloadFromUrl(
                                                guarantor?.guarantorBusinessPhoto,
                                                "guarantorBusinessPhoto",
                                              )
                                            }
                                            color="#000000"
                                            className="w-5 h-5 cursor-pointer hover:scale-110 transition"
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="w-full flex flex-col items-center justify-center text-center py-10 text-gray-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-10 w-10 mb-2 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 17v-6a2 2 0 012-2h2a2 2 0 012 2v6m-6 0h6"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 7a4 4 0 100-8 4 4 0 000 8z"
                      />
                    </svg>
                    <p className="text-[16px] font-medium">
                      No guarantor data available
                    </p>
                  </div>
                )}
              </div>
            </>
          )}
          {activeTab === "Penalties" && (
            <>
              <div className="h-[35px] mb-[15px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                <p className="text-[#000000] font-medium text-[20px]">
                  Penalties
                </p>
              </div>

              <div className="w-full">
                {penalties?.transactions?.length > 0 ? (
                  <table className="table-auto w-full divide-y divide-gray-200 border">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border">
                          Loan ID
                        </th>
                        <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border">
                          Date
                        </th>
                        <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border">
                          Reference
                        </th>
                        <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border">
                          Note
                        </th>
                        <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border">
                          Status
                        </th>
                        <th className="px-4 py-2 text-right text-sm font-medium text-gray-700 border">
                          Penalty Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {penalties?.transactions?.map((tx) => (
                        <tr key={tx.id}>
                          <td className="px-4 py-2 text-sm text-gray-700 border">
                            {penalties.loanId?.slice(0, 25)}
                          </td>
                          <td className="px-4 py-2 text-sm text-gray-700 border">
                            {
                              new Date(tx.paymentDate)
                                .toISOString()
                                .replace("T", " ")
                                .split(".")[0]
                            }
                          </td>
                          <td className="px-4 py-2 text-sm text-gray-700 border">
                            {tx?.paymentReference?.slice(0, 25)}
                          </td>
                          <td className="px-4 py-2 text-sm text-gray-700 border">
                            {tx.note}
                          </td>
                          <td className="px-4 py-2 capitalize text-sm text-gray-700 border">
                            {tx.status}
                          </td>
                          <td
                            className={`px-4 py-2 text-sm text-right border ${
                              tx.type === "debit" ? "text-red-600" : ""
                            }`}
                          >
                            {tx.type === "debit"
                              ? formatAmount(tx.amount)
                              : "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    {penalties?.transactions?.length > 0 && (
                      <tfoot className="bg-gray-100 font-semibold">
                        <tr>
                          <td
                            className="px-4 py-2 text-sm text-gray-700"
                            colSpan="5"
                          >
                            Total Penalty Charged
                          </td>
                          <td
                            className="px-4 py-2 text-sm text-right text-red-600"
                            colSpan="2"
                          >
                            {formatAmount(penalties.totalPenaltyCharged)}
                          </td>
                        </tr>
                        <tr>
                          <td
                            className="px-4 py-2 text-sm text-gray-700"
                            colSpan="5"
                          >
                            Total Penalty Paid
                          </td>
                          <td
                            className="px-4 py-2 text-sm text-right text-green-600"
                            colSpan="2"
                          >
                            {formatAmount(penalties.totalPenaltyPaid)}
                          </td>
                        </tr>
                        <tr>
                          <td
                            className="px-4 py-2 text-sm text-gray-700"
                            colSpan="5"
                          >
                            Outstanding Penalty
                          </td>
                          <td
                            className="px-4 py-2 text-sm text-right text-gray-800"
                            colSpan="2"
                          >
                            {formatAmount(penalties.outstandingPenalty)}
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                ) : (
                  <div className="my-[20px] flex items-center gap-[10px]">
                    <Info size={17} />
                    <p>No loan penalties are available</p>
                  </div>
                )}
              </div>
            </>
          )}
          {activeTab === "Action" && (
            <>
              <div className="h-[35px] mb-[10px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                <p className="text-[#000000] font-medium text-[20px]">
                  Loan Actions
                </p>
              </div>
              <div className="h-[500px] mb-[20px] p-[10px] bg-white w-full">
                <p className="font-light text-[15px] mb-[10px] text-[#000000]">
                  Select what action you wish to perform on this laon
                </p>

                <div className="flex items-center gap-[20px] justify-between flex-wrap">
                  {/* <div className="w-[49%]">
                    <ActionCard
                      icon={<Folder color="#000000" />}
                      title="Generate a loan statement"
                      subtitle="Generate a loan statement for this loan"
                    />
                  </div>
                  <div className="w-[49%]">
                    <ActionCard
                      icon={<FileText color="#000000" />}
                      title="Add a Journal Payment"
                      subtitle="Record a payment made outside the system, such as via cheque or bank transfer"
                    />
                  </div> */}

                  {hasPermission(
                    auth?.roles,
                    "fb9240c3-e029-1796-295a-dfe13c38dccf",
                  ) &&
                    loan?.status?.toLowerCase() === "pending" && (
                      <div className="w-[49%]">
                        <ActionCard
                          icon={<Split color="#000000" />}
                          title="Disburse Loan"
                          subtitle="Release funds to the customer's account or mobile wallet."
                          handleClick={toggleDisburseDetails}
                        />
                      </div>
                    )}
                  {/* <div className="w-[49%]">
                    <ActionCard
                      icon={<Bell color="#000000" />}
                      title="Send Notifications"
                      subtitle="Update customers about payments, approvals, or overdue amounts."
                    />
                  </div>
                  <div className="w-[49%]">
                    <ActionCard
                      icon={<Siren color="#000000" />}
                      title="Freeze/Cancel Loan"
                      subtitle="Suspend or terminate a loan due to fraud, default, or other issues."
                    />
                  </div> */}
                  <div className="w-[49%]">
                    <ActionCard
                      icon={<Siren color="#000000" />}
                      title="Record Manual Payment"
                      subtitle="Record a payment made outside the system, such as via cheque or bank transfer"
                      handleClick={() => {
                        setOpenManualTransaction(true);
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          {activeTab === "Loan Schedule" && (
            <>
              <div className="h-[35px] mb-[10px] w-full border-b-[0.7px] border-[#A9A9A9] flex items-center justify-between">
                <p className="text-[#000000] font-medium text-[20px]">
                  Loan Schedule
                </p>
              </div>
              {loan?.repayments?.length > 0 ? (
                <div className="w-full bg-white mt-[15px] mb-[20px] overflow-x-auto">
                  <table className="min-w-full text-left text-sm">
                    <thead className="bg-gray-100 text-xs uppercase text-gray-600">
                      <tr>
                        <th className="px-4 border py-2">#</th>
                        <th className="px-4 border py-2">Due Date</th>
                        <th className="px-4 border py-2">Schedule Amount</th>
                        <th className="px-4 border py-2">Penalties</th>
                        <th className="px-4 border py-2">
                          Penalties Last Applied Date
                        </th>
                        <th className="px-4 border py-2">Total Payable</th>
                        <th className="px-4 border py-2">Paid Amount</th>
                        <th className="px-4 border py-2">Payment Date</th>
                        <th className="px-4 border py-2">Status</th>
                      </tr>
                    </thead>
                    <tbody className="text-gray-700">
                      {loan?.repayments?.map((item, index) => {
                        const status = getStatus(item.paid, item);
                        return (
                          <tr key={item.id} className="border">
                            <td className="px-4 py-2 border">{index + 1}</td>
                            <td className="px-4 py-2 border">
                              {formattedDate(item.dueDate)}
                            </td>
                            <td className="px-4 py-2 border">
                              {formatAmount(item.amount)}
                            </td>
                            <td className="px-4 py-2 border">
                              {formatAmount(item.penaltyAccrued)}
                            </td>
                            <td className="px-4 py-2 border">
                              {item.penaltyLastAppliedDate
                                ? dayjs(item.penaltyLastAppliedDate).format(
                                    "DD MMM YYYY",
                                  )
                                : "—"}
                            </td>
                            <td className="px-4 py-2 border">
                              {formatAmount(
                                Number(item.penaltyAccrued) +
                                  Number(item.amount),
                              )}
                            </td>
                            <td className="px-4 py-2 border">
                              {formatAmount(item.paidAmount)}
                            </td>
                            <td className="px-4 py-2 border">
                              {item.paymentDate
                                ? dayjs(item.paymentDate).format("DD MMM YYYY")
                                : "—"}
                            </td>
                            <td className="px-4 py-2 border">
                              <span
                                className={`px-3 py-1 text-xs font-semibold rounded-full ${status.color}`}
                              >
                                {status.label}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="w-full flex items-center gap-[10px] mt-10 text-gray-500">
                  <Info size={17} />
                  <p className="text-[15px] font-medium">
                    No loan schedule available
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default Loan;
